import { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { useNavigate } from "react-router-dom";

const SignupService = () => {
  const [input, setInput] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [successPopUp, setSuccessPopUp] = useState(false);
  const navigate = useNavigate();

  const togglePassword = () => setShowPassword((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = (input, setValidationErrors) => {
    const errors = {};
    if (!input.Name || input.Name.trim() === "") {
      errors.Name = "Name is required.";
    }
    if (!input.EmailID || input.EmailID.trim() === "") {
      errors.EmailID = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.EmailID)) {
      errors.EmailID = "Email is not valid.";
    }
    if (!input.MobileNo || input.MobileNo.trim() === "") {
      errors.MobileNo = "Mobile no. is required.";
    } else if (!/^[6-9]\d{9}$/.test(input.MobileNo)) {
      errors.MobileNo = "Enter a valid  mobile number.";
    }

    if (!input.Password || input.Password.trim() === "") {
      errors.Password = "Password is required.";
    } else if (input.Password.length < 8) {
      errors.Password = "Password must be at least 8 characters long.";
    }
    if (!input.Pincode || input.Pincode.trim() === "") {
      errors.Pincode = "Pincode is required.";
    }
    if (!input.Address || input.Address.trim() === "") {
      errors.Address = "Address is required.";
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };
       



  
  const handleSubmit = async (e) => {
    if (!validateForm(input, setValidationErrors)) {   
      return;
    }
    try {
      const bodyObject = {
        Name: input?.Name,
        MobileNo: input?.MobileNo,
        EmailID: input?.EmailID,
        Password: input?.Password,
        Pincode: input?.Pincode,
        Address: input?.Address,
        ReferralNo: input?.ReferralNo,
      };

      const res = await ApiCalling.request("POST", "/Signup", bodyObject, null);
      if (res?.statuscode === 1) {
        setInput({
          Name: "",
          EmailID: "",
          MobileNo: "",
          Password: "",
          Pincode: "",
          Address: "",
          ReferralNo: "",
        });
        setValidationErrors({});
        setSuccessPopUp(true);
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else {
        console.error(res?.msg, { toastId: "SignupService error" });
      }
    } catch (error) {
      console.error("Error SignupService :", error);
    }
  };

  return {
    input,
    handleSubmit,
    handleChange,
    showPassword,
    togglePassword,
    validationErrors,
    successPopUp,
    setSuccessPopUp,
  };
};

export default SignupService;
